export const iconFontAwesomeCommunicationEnvelopeOpen = (
	<i className="fa-solid fa-envelope-open"></i>
);
